import { TIMEOUT } from 'common/domain/constants.errors';

class FailedActionController {

  $onInit() {
    if (this.isMobileApp) {
      this.floatingActionButtons = this.getFloatingActionButtons();
    }
  }

  close() {
    if (this.avoidCallbackOnClose) {
      return;
    }

    this.onDismiss();
  }

  hideModalAndOnDismiss() {
    if (this.onClick) {
      this.onClick();
    }
    $('.modal').modal('hide');
    this.onDismiss();
  }

  getClass() {
    return {
      'mod-size': this.modSize,
    };
  }

  getFloatingActionButtons() {
    return [
      {
        literal: this.buttonText
      }
    ];
  }

  isTimeoutError() {
    return this.description === TIMEOUT;
  }
}
export default FailedActionController;



// WEBPACK FOOTER //
// ./client/app/components/failedAction/failedAction.controller.js